<script setup lang="ts">
import { computed } from 'vue';
import { Text } from '@sitecore-jss/sitecore-jss-vue';

const props = defineProps<{
  field?: any;
  editable?: boolean;
  tag?: string;
  encode?: boolean;
}>();

const isEditable = computed(() => props.editable !== false && Boolean(props.field?.editable));
const hasValue = computed(() => {
  const v = props.field?.value;
  return v !== undefined && v !== '';
});
const segments = computed<string[]>(() => {
  const value = props.field?.value;
  if (!value || typeof value !== 'string') return [];
  return value.split('&');
});
</script>

<template>
  <Text v-if="isEditable" :field="field" :editable="true" :tag="tag" />
  <component :is="tag || 'span'" v-else-if="hasValue">
    <template v-for="(seg, i) in segments" :key="i">
      <span v-if="i > 0" style="font-family: 'sans-serif'">&amp;</span>{{ seg }}
    </template>
  </component>
</template>
